<script setup>
import { computed } from 'vue'
import VideoPlayer from '../../VideoPlayer.vue'

const { item } = defineProps({
  item: Object,
})

const imageKey = computed(() => item.properties.darioImageKey)

const media = computed(() => item.enrichment.program?.headerImages?.[imageKey.value])
const MediaComponent = computed(() => (media.value?.type === 'image' ? 'img' : VideoPlayer))
const mediaUrl = computed(() => media.value?.src || item.properties.fallbackVideo)
</script>

<template>
  <MediaComponent class="absolute top-0 left-0 w-full h-full object-contain object-left" :src="mediaUrl" :loop="item.properties.loop" autoplay muted />
</template>
